export * from './ZoomLevelIndicator';
export {default} from './ZoomLevelIndicator';
